document.addEventListener('DOMContentLoaded', function () {
  var swiper = new Swiper('.dtc-swiper-container', {
    slidesPerView: 1.1,
    spaceBetween: 10,
    loop: true,
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    breakpoints: {
      768: {
        slidesPerView: 4.2,
        spaceBetween: 30
      }
    }
  });
});